import { render, staticRenderFns } from "./VerificationIndex.vue?vue&type=template&id=5f570b78&"
import script from "./VerificationIndex.vue?vue&type=script&lang=js&"
export * from "./VerificationIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports